import { Controller } from "@hotwired/stimulus"

const ROTATION_STEP = -90

export default class extends Controller {
  static values = {
    rotation: { type: Number, default: 0 },
  }
  static targets = ["image", "field"]

  declare rotationValue: number
  declare readonly imageTarget: HTMLImageElement
  declare readonly hasImageTarget: boolean
  declare readonly fieldTarget: HTMLInputElement
  declare readonly hasFieldTarget: boolean

  rotate(event: Event) {
    this.rotationValue = (this.rotationValue + ROTATION_STEP) % 360
  }

  rotationValueChanged(value: number) {
    if (!this.hasFieldTarget || !this.hasImageTarget) {
      return
    }

    this.imageTarget.style.transform = `rotate(${value}deg)`
    this.fieldTarget.value = String(value)
  }
}
